import { useTranslation } from 'react-i18next';
import { AlloyButton } from 'cat-ecommerce-alloy';
import cx from 'classnames';
import PropTypes from 'prop-types';
import useLogin from '@app/components/login/hooks/useLogin';
import {
  DealerLocatorModalWrapper,
  CheckPriceDescription as CheckPriceDescriptionBlocks
} from '@app/components/dealer-locator-react';
import { useModal } from '@cat-ecom/pcc-components';
import WrapperContainer from '@app/components/common/WrapperContainer';

const CheckPriceActions = ({ showSmallVariant }) => {
  const [t] = useTranslation();

  const modal = useModal({
    isRequired: false,
    heading: t('CAT_CHECK_PRICE'),
    backButton: false,
    size: 'md'
  });
  const { login } = useLogin();

  return (
    <div
      className={cx({
        'row align-items-center': !showSmallVariant
      })}
    >
      <div
        className={cx({
          'col-12 col-lg-auto pe-lg-0': !showSmallVariant,
          'py-1': showSmallVariant
        })}
      >
        <AlloyButton
          buttonType="secondary"
          className="w-100"
          onClick={modal.initiatorProps.onClick}
          size={showSmallVariant ? 'dynamic' : 'large'}
        >
          {t('CAT_CHECK_PRICE')}
        </AlloyButton>
      </div>
      {!showSmallVariant && (
        <div className="col-12 col-lg py-2">
          <AlloyButton
            buttonType="ghost"
            onClick={login}
            size="dynamic"
            className="ps-0 ps-lg-4"
          >
            {t('CAT_VIEW_CUSTOMER_PRICE')}
          </AlloyButton>
        </div>
      )}
      <WrapperContainer>
        <DealerLocatorModalWrapper modal={modal}>
          <CheckPriceDescriptionBlocks />
        </DealerLocatorModalWrapper>
      </WrapperContainer>
    </div>
  );
};

export default CheckPriceActions;

CheckPriceActions.propTypes = {
  showSmallVariant: PropTypes.bool
};
